import { Link, useSearchParams } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { ResetPasswordForm } from '../components/auth/ResetPasswordForm';
import { PlatformCheckoutBrand } from '../components/auth/PlatformCheckoutBrand';
import { PlatformCheckoutShell } from '../components/auth/PlatformCheckoutShell';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get('oobCode');
  const mode = searchParams.get('mode');
  const returnUrl = searchParams.get('returnUrl') ?? undefined;

  const loginPath = returnUrl
    ? `/login?returnUrl=${encodeURIComponent(returnUrl)}`
    : '/login';

  const hasValidCode = Boolean(oobCode && mode === 'resetPassword');

  const left = (
    <>
      <PlatformCheckoutBrand className="mb-6" variant="icon" />
      <h1 className="mb-2 text-xl font-bold text-gray-900 dark:text-white sm:text-2xl">
        Choose a new password
      </h1>
      <p className="text-sm text-gray-600 dark:text-gray-400 sm:text-base">
        Your new password must be at least 8 characters.
      </p>
    </>
  );

  return (
    <PlatformCheckoutShell asideVariant="onboarding" left={left}>
      <div className="mx-auto w-full max-w-md lg:mx-0 lg:ml-10 lg:max-w-lg">
        {hasValidCode ? (
          <ResetPasswordForm oobCode={oobCode!} loginPath={loginPath} />
        ) : (
          <div className="rounded-lg border border-amber-200 bg-amber-50 p-6 text-center dark:border-amber-800 dark:bg-amber-900/20">
            <AlertCircle className="mx-auto mb-3 h-10 w-10 text-amber-600 dark:text-amber-400" aria-hidden />
            <p className="mb-4 text-sm text-amber-900 dark:text-amber-200">
              This reset link is missing or invalid. Please request a new password reset email.
            </p>
            <Link
              to="/forgot-password"
              className="text-sm font-medium text-primary-600 hover:text-primary-800 dark:text-primary-300"
            >
              Request a new reset link
            </Link>
          </div>
        )}
      </div>
    </PlatformCheckoutShell>
  );
}
